import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const TextInputComponent = ({ textInput = {} }) => {
  const { hoveredtextInputision, files } = useContext(CanvasContext);

  const isHovered = textInput.id === hoveredtextInputision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = textInput;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = textInput;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = textInput;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = textInput;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = textInput;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        textInput.backgroundImage &&
        textInput.backgroundImage.startsWith("./")
      ) {
        const imageName = textInput.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(textInput.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [textInput.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        textInput.labelbackgroundImage &&
        textInput.labelbackgroundImage.startsWith("./")
      ) {
        const imageName = textInput.labelbackgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(textInput.labelbackgroundImage);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [textInput.labelbackgroundImage, files]);

  const focusedStyles =
    isDivFocused && textInput.pseudoClass === "focus"
      ? {
          width: textInput.focusedwidth || textInput.width || "200px",
          height: textInput.focusedheight || textInput.height || "auto",

          padding: textInput.focusedpadding || textInput.padding || "0",
          paddingTop:
            textInput.focusedpaddingTop || textInput.focusedpadding || "0",
          paddingRight:
            textInput.focusedpaddingRight || textInput.focusedpadding || "0",
          paddingBottom:
            textInput.focusedpaddingBottom || textInput.focusedpadding || "0",
          paddingLeft:
            textInput.focusedpaddingLeft || textInput.focusedpadding || "0",
          margin: textInput.focusedmargin || textInput.margin || "0px",
          marginTop:
            textInput.focusedmarginTop || textInput.focusedmargin || "0px",
          marginRight:
            textInput.focusedmarginRight || textInput.focusedmargin || "0px",
          marginBottom:
            textInput.focusedmarginBottom || textInput.focusedmargin || "0px",
          marginLeft:
            textInput.focusedmarginLeft || textInput.focusedmargin || "10px",

          borderTop:
            textInput.focusedborderTop ||
            textInput.focusedborder ||
            textInput.border ||
            "1px solid #000000",
          borderRight:
            textInput.focusedborderRight ||
            textInput.focusedborder ||
            textInput.border ||
            "1px solid #000000",
          borderBottom:
            textInput.focusedborderBottom ||
            textInput.focusedborder ||
            textInput.border ||
            "1px solid #000000",
          borderLeft:
            textInput.focusedborderLeft ||
            textInput.focusedborder ||
            textInput.border ||
            "1px solid #000000",
          borderSapcing:
            textInput.focusedborderSpacing || textInput.borderSpacing || "0px",
          borderCollapse:
            textInput.focusedborderCollapse ||
            textInput.borderCollapse ||
            "0px",
          borderRadius:
            textInput.focusedborderRadius || textInput.borderRadius || "0",
          outline: textInput.focusedoutline || textInput.outline || "none",

          position:
            textInput.focusedposition || textInput.position || "relative",
          top: textInput.focusedtop || textInput.top || "auto",
          right: textInput.focusedright || textInput.right || "auto",
          bottom: textInput.focusedbottom || textInput.bottom || "auto",
          left: textInput.focusedleft || textInput.left || "auto",
          zIndex: textInput.focusedzIndex || textInput.zIndex || "auto",

          color: textInput.focusedcolor || textInput.color || "#000000",
          backgroundColor:
            textInput.focusedbackgroundColor ||
            textInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (textInput.focusedbackgroundImage) {
              if (textInput.focusedbackgroundImage.startsWith("./")) {
                const imageName = textInput.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${textInput.focusedbackgroundImage})`;
            }
            if (textInput.backgroundImage) {
              if (textInput.backgroundImage.startsWith("./")) {
                const imageName = textInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${textInput.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            textInput.focusedbackgroundPosition ||
            textInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            textInput.focusedbackgroundSize ||
            textInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            textInput.focusedbackgroundRepeat ||
            textInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            textInput.focusedbackgroundAttachment ||
            textInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            textInput.focusedboxShadow || textInput.boxShadow || "none",
          opacity: textInput.focusedOpacity || textInput.opacity || 1,
          display: textInput.focuseddisplay || textInput.display || "inline",

          fontFamily:
            textInput.focusedfontFamily || textInput.fontFamily || "inherit",
          fontSize:
            textInput.focusedfontSize || textInput.fontSize || "inherit",
          fontWeight:
            textInput.focusedfontWeight || textInput.fontWeight || "normal",
          fontStyle:
            textInput.focusedfontStyle || textInput.fontStyle || "normal",
          fontVariant:
            textInput.focusedfontVariant || textInput.fontVariant || "normal",
          lineHeight:
            textInput.focusedlineHeight || textInput.lineHeight || "normal",
          textShadow:
            textInput.focusedtextShadow || textInput.textShadow || "none",
          textAlign:
            textInput.focusedtextAlign || textInput.textAlign || "left",
          verticalAlign:
            textInput.focusedverticalAlign ||
            textInput.verticalAlign ||
            "baseline",
          textDecoration:
            textInput.focusedtextDecoration ||
            textInput.textDecoration ||
            "none",
          textTransform:
            textInput.focusedtextTransform || textInput.textTransform || "none",
          letterSpacing:
            textInput.focusedletterSpacing ||
            textInput.letterSpacing ||
            "normal",
          wordSpacing:
            textInput.focusedwordSpacing || textInput.wordSpacing || "normal",
          textIndent:
            textInput.focusedtextIndent || textInput.textIndent || "0",
          whiteSpace:
            textInput.focusedwhiteSpace || textInput.whiteSpace || "normal",
          textOverflow:
            textInput.focusedtextOverflow || textInput.textOverflow || "clip",
          direction: textInput.focuseddirection || textInput.direction || "ltr",
          unicodeBidi:
            textInput.focusedunicodeBidi || textInput.unicodeBidi || "normal",
          writingMode:
            textInput.focusedwritingMode ||
            textInput.writingMode ||
            "horizontal-tb",

          cursor: textInput.focusedcursor || textInput.cursor || "default",
          transform:
            textInput.focusedtransform || textInput.transform || "none",
          transition:
            textInput.focusedtransition || textInput.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && textInput.pseudoClass === "hover"
      ? {
          width: textInput.hoveredwidth || textInput.width || "200px",
          height: textInput.hoveredheight || textInput.height || "auto",

          padding: textInput.hoveredpadding || textInput.padding || "0",
          paddingTop:
            textInput.hoveredpaddingTop || textInput.hoveredpadding || "0",
          paddingRight:
            textInput.hoveredpaddingRight || textInput.hoveredpadding || "0",
          paddingBottom:
            textInput.hoveredpaddingBottom || textInput.hoveredpadding || "0",
          paddingLeft:
            textInput.hoveredpaddingLeft || textInput.hoveredpadding || "0",
          margin: textInput.hoveredmargin || textInput.margin || "0px",
          marginTop:
            textInput.hoveredmarginTop || textInput.hoveredmargin || "0px",
          marginRight:
            textInput.hoveredmarginRight || textInput.hoveredmargin || "0px",
          marginBottom:
            textInput.hoveredmarginBottom || textInput.hoveredmargin || "0px",
          marginLeft:
            textInput.hoveredmarginLeft || textInput.hoveredmargin || "10px",

          borderTop:
            textInput.hoveredborderTop ||
            textInput.hoveredborder ||
            textInput.border ||
            "1px solid #000000",
          borderRight:
            textInput.hoveredborderRight ||
            textInput.hoveredborder ||
            textInput.border ||
            "1px solid #000000",
          borderBottom:
            textInput.hoveredborderBottom ||
            textInput.hoveredborder ||
            textInput.border ||
            "1px solid #000000",
          borderLeft:
            textInput.hoveredborderLeft ||
            textInput.hoveredborder ||
            textInput.border ||
            "1px solid #000000",
          borderSapcing:
            textInput.hoveredborderSpacing || textInput.borderSpacing || "0px",
          borderCollapse:
            textInput.hoveredborderCollapse ||
            textInput.borderCollapse ||
            "0px",
          borderRadius:
            textInput.hoveredborderRadius || textInput.borderRadius || "0",
          outline: textInput.hoveredoutline || textInput.outline || "none",

          position:
            textInput.hoveredposition || textInput.position || "relative",
          top: textInput.hoveredtop || textInput.top || "auto",
          right: textInput.hoveredright || textInput.right || "auto",
          bottom: textInput.hoveredbottom || textInput.bottom || "auto",
          left: textInput.hoveredleft || textInput.left || "auto",
          zIndex: textInput.hoveredzIndex || textInput.zIndex || "auto",

          color: textInput.hoveredcolor || textInput.color || "#000000",
          backgroundColor:
            textInput.hoveredbackgroundColor ||
            textInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (textInput.hoveredbackgroundImage) {
              if (textInput.hoveredbackgroundImage.startsWith("./")) {
                const imageName = textInput.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${textInput.hoveredbackgroundImage})`;
            }
            if (textInput.backgroundImage) {
              if (textInput.backgroundImage.startsWith("./")) {
                const imageName = textInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${textInput.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            textInput.hoveredbackgroundPosition ||
            textInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            textInput.hoveredbackgroundSize ||
            textInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            textInput.hoveredbackgroundRepeat ||
            textInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            textInput.hoveredbackgroundAttachment ||
            textInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            textInput.hoveredboxShadow || textInput.boxShadow || "none",
          opacity: textInput.hoveredOpacity || textInput.opacity || 1,
          display: textInput.hovereddisplay || textInput.display || "inline",

          fontFamily:
            textInput.hoveredfontFamily || textInput.fontFamily || "inherit",
          fontSize:
            textInput.hoveredfontSize || textInput.fontSize || "inherit",
          fontWeight:
            textInput.hoveredfontWeight || textInput.fontWeight || "normal",
          fontStyle:
            textInput.hoveredfontStyle || textInput.fontStyle || "normal",
          fontVariant:
            textInput.hoveredfontVariant || textInput.fontVariant || "normal",
          lineHeight:
            textInput.hoveredlineHeight || textInput.lineHeight || "normal",
          textShadow:
            textInput.hoveredtextShadow || textInput.textShadow || "none",
          textAlign:
            textInput.hoveredtextAlign || textInput.textAlign || "left",
          verticalAlign:
            textInput.hoveredverticalAlign ||
            textInput.verticalAlign ||
            "baseline",
          textDecoration:
            textInput.hoveredtextDecoration ||
            textInput.textDecoration ||
            "none",
          textTransform:
            textInput.hoveredtextTransform || textInput.textTransform || "none",
          letterSpacing:
            textInput.hoveredletterSpacing ||
            textInput.letterSpacing ||
            "normal",
          wordSpacing:
            textInput.hoveredwordSpacing || textInput.wordSpacing || "normal",
          textIndent:
            textInput.hoveredtextIndent || textInput.textIndent || "0",
          whiteSpace:
            textInput.hoveredwhiteSpace || textInput.whiteSpace || "normal",
          textOverflow:
            textInput.hoveredtextOverflow || textInput.textOverflow || "clip",
          direction: textInput.hovereddirection || textInput.direction || "ltr",
          unicodeBidi:
            textInput.hoveredunicodeBidi || textInput.unicodeBidi || "normal",
          writingMode:
            textInput.hoveredwritingMode ||
            textInput.writingMode ||
            "horizontal-tb",

          cursor: textInput.hoveredcursor || textInput.cursor || "default",
          transform:
            textInput.hoveredtransform || textInput.transform || "none",
          transition:
            textInput.hoveredtransition || textInput.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && textInput.pseudoClass === "active"
      ? {
          width: textInput.activatedwidth || textInput.width || "200px",
          height: textInput.activatedheight || textInput.height || "auto",

          padding: textInput.activatedpadding || textInput.padding || "0",
          paddingTop:
            textInput.activatedpaddingTop || textInput.activatedpadding || "0",
          paddingRight:
            textInput.activatedpaddingRight ||
            textInput.activatedpadding ||
            "0",
          paddingBottom:
            textInput.activatedpaddingBottom ||
            textInput.activatedpadding ||
            "0",
          paddingLeft:
            textInput.activatedpaddingLeft || textInput.activatedpadding || "0",
          margin: textInput.activatedmargin || textInput.margin || "0px",
          marginTop:
            textInput.activatedmarginTop || textInput.activatedmargin || "0px",
          marginRight:
            textInput.activatedmarginRight ||
            textInput.activatedmargin ||
            "0px",
          marginBottom:
            textInput.activatedmarginBottom ||
            textInput.activatedmargin ||
            "0px",
          marginLeft:
            textInput.activatedmarginLeft || textInput.activatedmargin || "10px",

          borderTop:
            textInput.activatedborderTop ||
            textInput.activatedborder ||
            textInput.border ||
            "1px solid #000000",
          borderRight:
            textInput.activatedborderRight ||
            textInput.activatedborder ||
            textInput.border ||
            "1px solid #000000",
          borderBottom:
            textInput.activatedborderBottom ||
            textInput.activatedborder ||
            textInput.border ||
            "1px solid #000000",
          borderLeft:
            textInput.activatedborderLeft ||
            textInput.activatedborder ||
            textInput.border ||
            "1px solid #000000",
          borderSapcing:
            textInput.activatedborderSpacing ||
            textInput.borderSpacing ||
            "0px",
          borderCollapse:
            textInput.activatedborderCollapse ||
            textInput.borderCollapse ||
            "0px",
          borderRadius:
            textInput.activatedborderRadius || textInput.borderRadius || "0",
          outline: textInput.activatedoutline || textInput.outline || "none",

          position:
            textInput.activatedposition || textInput.position || "relative",
          top: textInput.activatedtop || textInput.top || "auto",
          right: textInput.activatedright || textInput.right || "auto",
          bottom: textInput.activatedbottom || textInput.bottom || "auto",
          left: textInput.activatedleft || textInput.left || "auto",
          zIndex: textInput.activatedzIndex || textInput.zIndex || "auto",

          color: textInput.activatedcolor || textInput.color || "#000000",
          backgroundColor:
            textInput.activatedbackgroundColor ||
            textInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (textInput.activatedbackgroundImage) {
              if (textInput.activatedbackgroundImage.startsWith("./")) {
                const imageName = textInput.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${textInput.activatedbackgroundImage})`;
            }
            if (textInput.backgroundImage) {
              if (textInput.backgroundImage.startsWith("./")) {
                const imageName = textInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${textInput.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            textInput.activatedbackgroundPosition ||
            textInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            textInput.activatedbackgroundSize ||
            textInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            textInput.activatedbackgroundRepeat ||
            textInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            textInput.activatedbackgroundAttachment ||
            textInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            textInput.activatedboxShadow || textInput.boxShadow || "none",
          opacity: textInput.activatedOpacity || textInput.opacity || 1,
          display: textInput.activateddisplay || textInput.display || "inline",

          fontFamily:
            textInput.activatedfontFamily || textInput.fontFamily || "inherit",
          fontSize:
            textInput.activatedfontSize || textInput.fontSize || "inherit",
          fontWeight:
            textInput.activatedfontWeight || textInput.fontWeight || "normal",
          fontStyle:
            textInput.activatedfontStyle || textInput.fontStyle || "normal",
          fontVariant:
            textInput.activatedfontVariant || textInput.fontVariant || "normal",
          lineHeight:
            textInput.activatedlineHeight || textInput.lineHeight || "normal",
          textShadow:
            textInput.activatedtextShadow || textInput.textShadow || "none",
          textAlign:
            textInput.activatedtextAlign || textInput.textAlign || "left",
          verticalAlign:
            textInput.activatedverticalAlign ||
            textInput.verticalAlign ||
            "baseline",
          textDecoration:
            textInput.activatedtextDecoration ||
            textInput.textDecoration ||
            "none",
          textTransform:
            textInput.activatedtextTransform ||
            textInput.textTransform ||
            "none",
          letterSpacing:
            textInput.activatedletterSpacing ||
            textInput.letterSpacing ||
            "normal",
          wordSpacing:
            textInput.activatedwordSpacing || textInput.wordSpacing || "normal",
          textIndent:
            textInput.activatedtextIndent || textInput.textIndent || "0",
          whiteSpace:
            textInput.activatedwhiteSpace || textInput.whiteSpace || "normal",
          textOverflow:
            textInput.activatedtextOverflow || textInput.textOverflow || "clip",
          direction:
            textInput.activateddirection || textInput.direction || "ltr",
          unicodeBidi:
            textInput.activatedunicodeBidi || textInput.unicodeBidi || "normal",
          writingMode:
            textInput.activatedwritingMode ||
            textInput.writingMode ||
            "horizontal-tb",

          cursor: textInput.activatedcursor || textInput.cursor || "default",
          transform:
            textInput.activatedtransform || textInput.transform || "none",
          transition:
            textInput.activatedtransition || textInput.transition || "none",
        }
      : {};

  const inputStyle = {
    width: textInput.width || "200px",
    height: textInput.height || "auto",

    margin: textInput.margin || "0px",
    marginTop: textInput.marginTop || textInput.margin || "0",
    marginRight: textInput.marginRight || textInput.margin || "0px",
    marginBottom: textInput.marginBottom || textInput.margin || "0",
    marginLeft: textInput.marginLeft || textInput.margin || "10px",
    padding: textInput.padding || "0px",
    paddingTop: textInput.paddingTop || textInput.padding || "0",
    paddingRight: textInput.paddingRight || textInput.padding || "0",
    paddingBottom: textInput.paddingBottom || textInput.padding || "0",
    paddingLeft: textInput.paddingLeft || textInput.padding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : textInput.borderTop || textInput.border || "1px solid #000000",
    borderRight: isHovered
      ? "1px dashed #555"
      : textInput.borderRight || textInput.border || "1px solid #000000",
    borderBottom: isHovered
      ? "1px dashed #555"
      : textInput.borderBottom || textInput.border || "1px solid #000000",
    borderLeft: isHovered
      ? "1px dashed #555"
      : textInput.borderLeft || textInput.border || "1px solid #000000",

    borderSapcing: textInput.borderSpacing || "0px",
    borderCollapse: textInput.borderCollapse || "0px",
    borderRadius: textInput.borderRadius || "0",
    outline: textInput.outline || "none",

    position: textInput.position || "static",
    top: textInput.top || "auto",
    right: textInput.right || "auto",
    bottom: textInput.bottom || "auto",
    left: textInput.left || "auto",
    zIndex: textInput.zIndex || "auto",

    color: textInput.color || "#000000",
    backgroundColor: textInput.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      textInput.focusedbackgroundPosition ||
      textInput.backgroundPosition ||
      "0% 0%",
    backgroundSize:
      textInput.focusedbackgroundSize || textInput.backgroundSize || "auto",
    backgroundRepeat:
      textInput.focusedbackgroundRepeat ||
      textInput.backgroundRepeat ||
      "repeat",
    backgroundAttachment:
      textInput.focusedbackgroundAttachment ||
      textInput.backgroundAttachment ||
      "scroll",

    fontSize: textInput.fontSize || "inherit",
    fontFamily: textInput.fontFamily || "inherit",
    fontWeight: textInput.fontWeight || "normal",
    fontStyle: textInput.fontStyle || "normal",
    fontVariant: textInput.fontVariant || "normal",
    lineHeight: textInput.lineHeight || "normal",
    textAlign: textInput.textAlign || "left",
    textDecoration: textInput.textDecoration || "none",
    textTransform: textInput.textTransform || "none",
    textShadow: textInput.textShadow || "none",
    verticalAlign: textInput.verticalAlign || "baseline",
    letterSpacing: textInput.letterSpacing || "normal",
    wordSpacing: textInput.wordSpacing || "normal",
    textIndent: textInput.textIndent || "0",
    whiteSpace: textInput.whiteSpace || "normal",
    textOverflow: textInput.textOverflow || "clip",
    direction: textInput.direction || "ltr",
    unicodeBidi: textInput.unicodeBidi || "normal",
    writingMode: textInput.writingMode || "horizontal-tb",

    opacity: textInput.opacity || "1",
    display: textInput.display || "inline",
    cursor: textInput.cursor || "auto",

    transform: textInput.transform || "none",
    transition: textInput.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: textInput.labelmargin || "0px",
    marginTop: textInput.labelmarginTop || textInput.labelmargin || "0",
    marginRight: textInput.labelmarginRight || textInput.labelmargin || "0px",
    marginBottom: textInput.labelmarginBottom || textInput.labelmargin || "0",
    marginLeft: textInput.labelmarginLeft || textInput.labelmargin || "0",
    padding: textInput.labelpadding || "0px",
    paddingTop: textInput.labelpaddingTop || textInput.labelpadding || "0",
    paddingRight: textInput.labelpaddingRight || textInput.labelpadding || "0",
    paddingBottom:
      textInput.labelpaddingBottom || textInput.labelpadding || "0",
    paddingLeft: textInput.labelpaddingLeft || textInput.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : textInput.labelborderTop || textInput.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : textInput.labelborderRight || textInput.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : textInput.labelborderBottom || textInput.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : textInput.labelborderLeft || textInput.labelborder || "none",

    borderSapcing: textInput.labelborderSpacing || "0px",
    borderCollapse: textInput.labelborderCollapse || "0px",
    borderRadius: textInput.labelborderRadius || "0",
    outline: textInput.labeloutline || "none",

    position: textInput.labelposition || "static",
    top: textInput.labeltop || "auto",
    right: textInput.labelright || "auto",
    bottom: textInput.labelbottom || "auto",
    left: textInput.labelleft || "auto",
    zIndex: textInput.labelzIndex || "auto",

    color: textInput.labelcolor || "#000000",
    backgroundColor: textInput.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      textInput.labelbackgroundPosition ||
      textInput.labelbackgroundPosition ||
      "0% 0%",
    backgroundSize:
      textInput.labelbackgroundSize || textInput.labelbackgroundSize || "auto",
    backgroundRepeat:
      textInput.labelbackgroundRepeat ||
      textInput.labelbackgroundRepeat ||
      "repeat",
    backgroundAttachment:
      textInput.labelbackgroundAttachment ||
      textInput.labelbackgroundAttachment ||
      "scroll",

    fontSize: textInput.labelfontSize || "inherit",
    fontFamily: textInput.labelfontFamily || "inherit",
    fontWeight: textInput.labelfontWeight || "normal",
    fontStyle: textInput.labelfontStyle || "normal",
    fontVariant: textInput.labelfontVariant || "normal",
    lineHeight: textInput.labellineHeight || "normal",
    textAlign: textInput.labeltextAlign || "left",
    textDecoration: textInput.labeltextDecoration || "none",
    textTransform: textInput.labeltextTransform || "none",
    textShadow: textInput.labeltextShadow || "none",
    verticalAlign: textInput.labelverticalAlign || "baseline",
    letterSpacing: textInput.labelletterSpacing || "normal",
    wordSpacing: textInput.labelwordSpacing || "normal",
    textIndent: textInput.labeltextIndent || "0",
    whiteSpace: textInput.labelwhiteSpace || "normal",
    textOverflow: textInput.labeltextOverflow || "clip",
    direction: textInput.labeldirection || "ltr",
    unicodeBidi: textInput.labelunicodeBidi || "normal",
    writingMode: textInput.labelwritingMode || "horizontal-tb",

    opacity: textInput.labelopacity || "1",
    display: textInput.display || "inline",
    cursor: textInput.cursor || "auto",

    transform: textInput.transform || "none",
    transition: textInput.transition || "none",
  };

  return (
    <>
        <label style={labelStyle}>{textInput.label || "Text Label"}</label>
        <input
          type="text"
          value={textInput.value}
          placeholder={textInput.placeholder || ""}
          style={inputStyle}
          onMouseEnter={() => setIsDivHovered(true)}
          onMouseLeave={() => setIsDivHovered(false)}
          onFocus={() => setIsDivFocused(true)}
          onBlur={() => setIsDivFocused(false)}
          onMouseDown={() => setIsDivActive(true)}
          onMouseUp={() => setIsDivActive(false)}
        />
      </>
  );
};

export default TextInputComponent;
